import _ from '@lodash';
import React, { useState } from 'react';
import { TableCell, Tooltip, IconButton } from '@material-ui/core';
import FiberManualRecord from '@material-ui/icons/FiberManualRecord';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';

import MeasurementEditService from '../service/MeasurementEditService';

function MeasurementStartRecordingButton(props) {
	const dispatch = useDispatch();
	const startRecording = () => { MeasurementEditService.startRecording(props.item.id).then(resp => { dispatch(showMessage({message: 'Recording started...'})) }); };

	return (
		<TableCell className="text-center" padding="none">
			<Tooltip title="Start Recording">
				<span>
					<IconButton onClick={() => startRecording()}>
						<FiberManualRecord fontSize="small" />
					</IconButton>
				</span>
			</Tooltip>
		</TableCell>
	);
}

export default MeasurementStartRecordingButton;
